export default function getResource(label, vars = []) {
    const resources = { saleCopy: 'Solde' };

    return resources[label];
}
